<template>
  <div class="datePicker">
    <div v-if="isPhone">
      <van-field
        readonly
        clickable
        name="calendar"
        :value="currentDate"
        label=""
        placeholder="点击选择日期"
        @click="showCalendar = true"
      />

      <van-popup
        v-model="showCalendar"
        round
        position="bottom"
        :style="{ height: '300px' }"
      >
        <van-datetime-picker
          @confirm="popupClose"
          :value="new Date()"
          type="datetime"
          title="选择完整时间"
        />
      </van-popup>
    </div>
    <el-date-picker
      v-else
      type="datetime"
      placeholder="选择日期"
      v-model="currentDate"
      style="width: 100%;"
      @change="popupClose"
    ></el-date-picker>
  </div>
</template>

<script>
import mixins from "./mixins";
import { isPhone } from "@/utils/utils";
import moment from 'moment'

export default {
  name: "dateTimePicker",
  mixins: [mixins],
  data() {
    return {
      showCalendar: false,
      form: {},
      isPhone: isPhone(),
      currentDate: '',
    };
  },
  methods: {
    popupClose(date) {
      this.currentDate = moment(date).format("YYYY-MM-DD HH:mm");
      this.change(this.currentDate)
      this.showCalendar = false
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>